import React, {Component} from "react";
import NewsStory from "./news-story.js";
import {getNewsFeed} from "../../../../modules/news_feed.js";

class NewsFeedBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            gotStories: false,
            stories: []
        };
    }

    async componentDidMount() {
        const {token, platformID } = this.props;
        let newStoriesResponse = await getNewsFeed(token, platformID);

        if (newStoriesResponse.data.success) {
            this.setState({gotStories: true, stories: newStoriesResponse.data.stories});
        }
    }

    printStories() {
        const {stories} = this.state;
        
        let parsedStories = stories.map((story) => {
            if (story && story.title && story.content) {
                return <NewsStory key={story.title} title={story.title} content={story.content}></NewsStory>
            }
            else {
                return "";
            }

            
        });

        return parsedStories;
    }

    render () {
        const {gotStories} = this.state;
        const {whitlelabelPrefix} = this.props

        if (!gotStories) {
            return (
                <div>
                    <div className='news_feed_title'>News</div>
                    <div>No news to show...</div>
                </div>
            ) 
        }
        else {
            return (
                <div className={ whitlelabelPrefix+'news_feed'}>
                    <div className={ whitlelabelPrefix+'news_feed_title'}>News</div>
                    <div className='news_stories_container'>
                        {this.printStories()}
                    </div>                
                </div>
            )
        }
    }

}

export default NewsFeedBase;


// WEBPACK FOOTER //
// ./src/components/containers/play-screen/news-feed/news-feed-base.js